var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["v-step", _vm.classes] }, [
    _c("input", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.debug,
          expression: "debug"
        }
      ],
      staticClass: "input",
      attrs: {
        type: "radio",
        id: _vm.id,
        name: _vm.computedName,
        disabled: ""
      },
      domProps: { checked: _vm.active },
      on: { change: _vm.handleChange }
    }),
    _vm._v(" "),
    _c("label", { staticClass: "label", attrs: { for: _vm.id } }, [
      _c(
        "span",
        { staticClass: "index" },
        [
          _vm._t(
            "index",
            [_vm._v("\n        " + _vm._s(_vm.api.displayIndex) + "\n      ")],
            null,
            _vm.api
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.defaultSlot
        ? _c(
            "span",
            { staticClass: "title" },
            [_vm._t("default", null, null, _vm.api)],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.withDivider ? _c("span", { staticClass: "divider" }) : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }